import Modal from 'react-modal';
import styled from 'styled-components';

export const ModalContainer = styled(Modal)`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 70%;
  border-radius: 14px;
  box-shadow: 0 4px 40px 0 rgba(0, 33, 89, 0.16);
  border: solid 1px #e4e7eb;
  background-color: white;
  padding-top: 34px;
  padding-bottom: 54px;
  padding-left: 54px;
  padding-right: 54px;
  border: 0px;
  outline: none;
  position: absolute;
  @media (max-width: 770px) {
    transform: translate(-50%, 0%);
    position: absolute;
    top: 100px;
    width: 90%;
    padding-top: 24px;
    padding-bottom: 24px;
    padding-left: 24px;
    padding-right: 24px;
    align-items: flex-start;
  }
  @media (max-width: 768px) {
    top: unset;
    height: 95vh;
  }
`;

export const Iframe = styled('iframe')`
  width: ${(props) => (props.isIframeLoaded ? '100%' : '0px')};
  height: ${(props) => (props.isIframeLoaded ? '100%' : '0px')};
`;

export const IframeContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const CancelButton = styled.div`
  align-self: flex-end;
  margin-bottom: 10px;
  margin-right: -20px;
  width: 24px;
  height: 24px;
  object-fit: contain;
  cursor: pointer;
  @media (max-width: 770px) {
    margin-right: -10px;
  }
`;
